module.exports = __webpack_public_path__ + "img/hk.70ead8a6.svg";